import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponent } from '../app.component';
import { environment } from '../../environments/environment';
import { ToastrService } from '../_services/toastr.service';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css'],
})
export class ConfirmEmailComponent implements OnInit {
  isConfirmed: boolean = false;
  email: string;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private appComponent: AppComponent,
    private toastrService: ToastrService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.appComponent.setTitle('Verify Email');
    this.email = localStorage.getItem('pendingEmail')

    this.route.queryParams.subscribe(params => {
      const userId = params['userId'];
      const code = params['code'];

      if (userId && code) {
        // El usuario ingresó al enlace de verificación
        // Puedes realizar las acciones necesarias aquí, como hacer una llamada al backend para confirmar el email del usuario.
        this.isConfirmed = true;
        this.authService.confirm_registration(userId, code).subscribe(res => {
          this.toastrService.info('Redireccionando...')
          this.toastrService.success('Email confirmado con éxito!')
          setTimeout(() => {
            this.router.navigate([''])
          }, 2000);
        })
      } else {
        // No se recibieron los parámetros esperados
        // Puedes mostrar un mensaje de error o redirigir al usuario a otra página.
      }
    });
  }
}
